import { render, staticRenderFns } from "./DialogImg.vue?vue&type=template&id=5bb227f3&scoped=true&"
import script from "./DialogImg.vue?vue&type=script&lang=js&"
export * from "./DialogImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb227f3",
  null
  
)

export default component.exports